var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"translation-button",attrs:{"type":"is-info","icon-left":"globe","data-cy":"translation"},on:{"click":function($event){return _vm.changeLanguage()}}},[_vm._v(" "+_vm._s(_vm.currentLanguage)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }